import React from "react";
import styled from "styled-components";
import FormContentLayout from "components/layout/FormContentLayout";
import DisappearingTile from "components/ui/DisappearingTile";
import { Body } from "components/ui/Text";
import Loading from "components/ui/Loading";
import TaxReturns from "components/shared/TaxReturns";
import { getCardApplicationStatus } from "store/api/apiSlice";
import { TaxReturnsWithAdvance } from "utils/hooks/useTaxReturnsWithAdvance";
import { PartnerSlug } from "types/general";
import Cta from "./Cta";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

interface Props {
  taxReturnsWithAdvance: TaxReturnsWithAdvance;
  partnerSlug?: PartnerSlug;
}

const TaxRefund: React.FC<Props> = ({ taxReturnsWithAdvance, partnerSlug }) => {
  const {
    data: ewaApplicationStatus,
    isLoading: isLoadingEwaApplicationStatus,
  } = getCardApplicationStatus();

  const { hasEligibleReturns } = taxReturnsWithAdvance;

  if (isLoadingEwaApplicationStatus) return <Loading />;

  // We're hiding this for CSC users that come in through tax to keep them focused on that product
  const canApplyForEwa =
    !ewaApplicationStatus?.cardApplicationComplete &&
    partnerSlug !== PartnerSlug.csc;

  return (
    <FormContentLayout
      heading={
        <>
          Your taxes are <em>done.</em>
        </>
      }
      subheading="It feels good to say that, doesn't it?"
      actions={
        <Cta canApplyForEwa={canApplyForEwa} hasAdvance={hasEligibleReturns} />
      }
    >
      <Wrapper>
        <DisappearingTile size="xl">
          <TaxReturns taxReturnsWithAdvance={taxReturnsWithAdvance} />
        </DisappearingTile>

        {canApplyForEwa && (
          <Body>
            The Reset card can do even more&mdash;<strong>all for free</strong>.
            Click below to apply for daily access to your income as you earn it.
            It only takes a few minutes.
          </Body>
        )}
      </Wrapper>
    </FormContentLayout>
  );
};

export default TaxRefund;
